export default __webpack_public_path__ + "static/media/followUp.4b0a6d12.png";